/* eslint-disable react-hooks/exhaustive-deps */
// @ts-check

import React, { useState, useEffect, useRef } from 'react';
import io from 'socket.io-client';
import { v4 as uuid } from 'uuid';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';

import { onPlayerCommand } from '../../helpers/youtube';
import { setCursors, setRadarViews } from '../../helpers/aceEditor';
import { searchFun } from '../../helpers/search';
import { socketRoom } from '../../helpers/socket-room';
import { ChatError } from '../Error/chatError';
import { LoadingScreen } from '../loading';
import { Editor } from '../Editor/Editor';
import {
  curMag,
  replaceAllCur,
  updateCurMag,
  updateUserCur,
  userCur,
  localUsers,
  setLocalUsers,
  setRadarView,
  radarViewMgr,
  setCursorState,
  cursorState,
  setLinerOwner,
  lineOwner,
} from '../../features/cursorSlice';
import {
  cursorFeature,
  lineOwnFeature,
  radarFeature,
  updateFeatures,
  deletionObj,
  deletionAnimationFeature,
} from '../../features/featuresSlice';

let socket;

const Chat = (data) => {
  const [name, setName] = useState('');
  const [room, setRoom] = useState('');
  const [allUsers, setAllUsers] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [flag, setFlag] = useState({ error: false, msg: '' });
  const [code, setCode] = useState(`
  // Welcome to MayCode Editor
  // This is a sample code to get you started
  //instruction to execute code: highlight line of code to run, one at a time
  //Verse 1
  search('travis greene')    
  //select a video of your choice from displayed results
  play(0,245)     //play video 
  seek(0,5.40)   //skip first song to 5.4 min in
  delay(0,7.0)    //increase song tempo (or playback speed) by 7
  pause(0)         //pause first song
  seek(0,180)    //skip or fast forward first(0) song to 3rd min (180s) in
  loopAt(1,180,120)   //loop second song for 2 min(120)
  stop(0)                         //stop first song
  
  //chorus
  search("cant stop this mc hammer")
  //select(0)a video
  play(1)
  
  
  //Verse 2
  search("cold heart elton")
  select(1)
  play(2)
  delay(2,6.5)
  pause(2)
  seek(2,2.40)
  loopAt(2,195,90)
  play(2)
  `);
  const [lastedit, setLastEdit] = useState('');
  const [loading, setLoading] = useState(true);
  const ENDPOINT = 'https://maycodeditor.132.145.23.94.nip.io/'; // https://maycodeditor.132.145.23.94.nip.io/  //'http://localhost:5555/';
  const FeatureEndpoint = 'https://monitor-server.132.145.23.94.nip.io/rest'; //'http://localhost:2020/rest'; //'https://monitor-server.132.145.23.94.nip.io/rest';
  const [search, setSearch] = useState('');
  const [searchResult, setSearchResult] = useState([]);
  const [videoId, setVideoId] = useState([]);
  const [player, setPlayer] = useState([]);
  const aceEditor = useRef();
  const [inter, setInter] = useState([]);

  const api = axios.create({
    baseURL: FeatureEndpoint,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const dispatch = useDispatch();

  // @ts-ignore
  let curMgr = useSelector(curMag);
  // @ts-ignore
  const userCursors = useSelector(userCur);

  const localUser = useSelector(localUsers);

  const radarView = useSelector(radarViewMgr);

  const cursorStateMgr = useSelector(cursorState);

  const lineOwnerMgr = useSelector(lineOwner);

  const cursorFeat = useSelector(cursorFeature);

  const radarFeat = useSelector(radarFeature);

  const lineOwnFeat = useSelector(lineOwnFeature);

  const deletionObjFeat = useSelector(deletionObj);

  const deletionAnimationFeat = useSelector(deletionAnimationFeature);

  const setLocalUser = (user) => {
    return dispatch(setLocalUsers(user));
  };

  const updateLineOwner = (owner) => {
    return dispatch(setLinerOwner(owner));
  };

  const updateCurMagStore = (mang) => {
    return dispatch(updateCurMag(mang));
  };

  const updateUserCurStore = (cur) => {
    return dispatch(updateUserCur(cur));
  };

  const replaceUserCurStore = (cur) => {
    return dispatch(replaceAllCur(cur));
  };

  const setRadarViewMgr = (radar) => {
    return dispatch(setRadarView(radar));
  };

  const setCursorStateMgr = (state) => {
    return dispatch(setCursorState(state));
  };

  const updateFeat = ({ type, state }) => {
    return dispatch(updateFeatures({ type, state }));
  };

  useEffect(() => {
    try {
      api.get('/controls').then((res) => {
        console.log(res.data.controls, 'controls');
        res.data.controls.map((feat) => {
          if (feat.name === 'LINEOWNER') {
            return updateFeat({ type: 'lineOwn', state: feat.status });
          }

          if (feat.name === 'CURSOR') {
            return updateFeat({ type: 'cursor', state: feat.status });
          }

          if (feat.name === 'RADAR') {
            return updateFeat({ type: 'radar', state: feat.status });
          }

          if (feat.name === 'POPUPBOX') {
            return updateFeat({ type: 'popUpBox', state: feat.status });
          }

          if (feat.name === 'DELETIONANIMATION') {
            updateFeat({ type: 'deletionAnimation', state: feat.status });
          }

          return null;
        });
      });
    } catch (error) {}
  }, [lineOwnFeat, radarFeat, cursorFeat, deletionAnimationFeat]);

  useEffect(() => {
    const { name, room, create } = data;
    const userId = uuid();

    socket = io(ENDPOINT);

    setRoom(room);
    setName(name);
    let userData;

    //an helper function for joining and creating room
    socketRoom(
      name,
      room,
      userId,
      create,
      socket,
      setLoading,
      flag,
      setFlag,
      aceEditor,
      userData,
      setLocalUser,
      updateCurMagStore,
      updateUserCurStore,
      curMgr,
      setRadarViewMgr,
      cursorFeat,
      radarFeat,
      api
    );
  }, [ENDPOINT, data, aceEditor]); //if endpoint is  reloaded, do useEffect

  useEffect(() => {
    // buttons command from the server
    socket.on('receiveCommand', ({ command, param }) => {
      onReceiveCommand(command, param);
    });

    return () => {};
  }, []);

  useEffect(() => {
    socket.on('notification', (notification) => {
      // @ts-ignore
      setNotifications((notifications) => [...notifications, notification]);
    });

    //perform roomData function as in socket.io and destructure data to select only 'users' and set into the users array
    socket.on('roomData', ({ users }) => {
      //console.log(users.users);
      const ids = users.users.map((user) => {
        // console.log(user.userId);
        return user.userId;
      });
      replaceUserCurStore(ids);
      setAllUsers(users);
    });

    socket.on('left', (data) => {
      // console.log(data);
      try {
        curMgr.removeCursor(data.users.userId);
        radarView.removeView(data.users.userId);
      } catch (error) {
        console.log('This user has no cursor yet');
      }
    });
  }, [curMgr]);

  //Concatenation; set notification and spread in the array, also add the notification from socket.io

  useEffect(() => {
    socket.on('cursorState', (message) => {
      setCursorStateMgr(message.cursorState);
    });
  }, [localUsers, cursorStateMgr]);

  useEffect(() => {
    //perform the emit codeMessage from socket.io, then set code and lastedit
    socket.on('codeMessage', (message) => {
      // console.log('message', message);
      if (message.text !== null) {
        setCode(message.text);
      }
      setLastEdit(message.user);
      // console.log('codeMessage');
    });
    //perform the emit cursor update from socket.io, then update the users cursor
    socket.on('cursor', (message) => {
      setLastEdit(message.user);
      // console.log('cursor update');
      if (curMgr) {
        setCursors(
          message.userId,
          message.user,
          message.color,
          message.userRow,
          message.userColumn,
          allUsers,
          curMgr,
          updateUserCurStore,
          localUser,
          cursorFeat
        );
      }

      if (localUser) {
        // if (localUser.userId === message.userId) {
        //   if (aceEditor.current) {
        //     // @ts-ignore
        //     aceEditor.current.editor.selection.on(
        //       'changeCursor',
        //       // @ts-ignore
        //       function (e) {
        //         // console.log('local user');
        //         if (localUser) {
        //           console.log(radarFeat);
        //           // @ts-ignore
        //           const cursor =
        //             // @ts-ignore
        //             aceEditor.current.editor.getCursorPosition();
        //           // console.log(localUser);
        //           try {
        //             if (radarFeat) {
        //               console.log(radarFeat, 'radarFeat1');
        //               radarView.setCursorRow(localUser.userId, cursor.row + 1);
        //             }

        //             return;
        //           } catch (error) {
        //             console.log('err');
        //           }
        //         }
        //       }
        //     );

        //     // @ts-ignore
        //     aceEditor.current.editor.selection.on(
        //       'changeScrollTop',
        //       // @ts-ignore
        //       function (scrollTop) {
        //         setTimeout(function () {
        //           // @ts-ignore
        //           const viewportIndices =
        //             AceCollabExt.AceViewportUtil.getVisibleIndexRange(
        //               // @ts-ignore
        //               aceEditor.current.editor
        //             );
        //           // @ts-ignore
        //           const rows = AceCollabExt.AceViewportUtil.indicesToRows(
        //             // @ts-ignore
        //             aceEditor.current.editor,
        //             viewportIndices.start,
        //             viewportIndices.end
        //           );
        //           if (localUser) {
        //             try {
        //               if (radarFeat) {
        //                 console.log(radarFeat, 'radarFeat2');
        //                 radarView.setViewRows(localUser.userId, rows);
        //               }
        //               return;
        //             } catch (error) {
        //               console.log('err');
        //             }
        //           }
        //         }, 0);
        //       }
        //     );
        //   }
        // } else {
        if (aceEditor.current) {
          try {
            // console.log('test');
            const from = 'chat';
            // console.log(radarFeat, 'radarFeat3');

            // console.log(radarFeat, 'radarFeat4');
            setRadarViews(
              message.userId,
              message.user,
              message.color,
              message.userRow,
              radarView,
              localUser,
              aceEditor,
              from
            );
          } catch (error) {
            console.log('err');
          }
        }
        // }
      }
    });
  }, [localUsers, curMgr, cursorFeat, radarView, localUser, radarViewMgr]);

  useEffect(() => {
    socket.on('receiveFeature', ({ feature }) => {
      console.log('receiveFeature', feature);
      if (feature.name === 'LINEOWNER') {
        updateFeat({ type: 'lineOwn', state: feature.status });
      }

      if (feature.name === 'CURSOR') {
        updateFeat({ type: 'cursor', state: feature.status });
      }

      if (feature.name === 'RADAR') {
        updateFeat({ type: 'radar', state: feature.status });
      }

      if (feature.name === 'POPUPBOX') {
        updateFeat({ type: 'popUpBox', state: feature.status });
      }

      if (feature.name === 'DELETIONANIMATION') {
        updateFeat({ type: 'deletionAnimation', state: feature.status });
      }
    });

    socket.on('receiveDeletedCommand', ({ user, body }) => {
      // console.log('receiveDeletedCommand', user, body);
      updateFeat({ type: 'deletionObj', state: { user, body } });
    });

    if (!cursorFeat) {
      try {
        curMgr.removeAll();
      } catch (error) {
        console.log(error);
      }
    }

    if (!radarFeat) {
      try {
        const radarView = document.getElementById('radar-view');
        // @ts-ignore
        radarView.style.display = 'none';
      } catch (error) {}
    }

    if (radarFeat) {
      try {
        const radarView = document.getElementById('radar-view');
        // @ts-ignore
        radarView.style.display = 'inline-block';
      } catch (error) {}
    }
  }, [cursorFeat, radarFeat, userCursors, deletionObjFeat]);

  useEffect(() => {
    // editor player command from the server
    socket.on('receivePlayerCommand', ({ command, param }) => {
      if (player) {
        // console.log('re', player);
        // console.log(searchResult);
        // player command executor function
        onPlayerCommand(
          command,
          param,
          player,
          setInter,
          inter,
          videoId,
          setSearchResult,
          socket,
          searchResult
        );
      }
    });
  }, [player, searchResult]);

  // Create Youtube player
  useEffect(() => {
    if (videoId) {
      // console.log(videoId);
      // @ts-ignore
      if (!window.YT) {
        // console.log('YT not loaded');
        // If not, load the script asynchronously
        setTimeout(() => {
          // console.log(videoId);
          const tag = document.createElement('script');
          tag.src = 'https://www.youtube.com/iframe_api';

          // onYouTubeIframeAPIReady will load the video after the script is loaded
          // @ts-ignore
          window.onYouTubeIframeAPIReady = YTPlayer;

          const firstScriptTag = document.getElementsByTagName('script')[0];
          // @ts-ignore
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }, 3000);
      } else {
        // console.log('YT loaded');
        // If script is already there, load the video directly
        YTPlayer();
      }
    }
  }, [videoId]);

  // youtube player
  const YTPlayer = () => {
    // console.log(id);
    videoId.forEach((id) => {
      // @ts-ignore
      let _player = new window.YT.Player(id, {
        height: '200',
        width: '300',
        videoId: id,
        events: {},
      });

      // console.log(player);
      // update the list of players
      // @ts-ignore
      setPlayer((player) => [...player, _player]);
    });
    //  console.log(player);
  };

  // function that run when button command is received
  const onReceiveCommand = (command, param) => {
    // search button click
    if (command === 'searchKey') {
      setSearch(param);
    }

    // search texts
    if (command === 'search') {
      console.log('searching');
      searchFun(param, setSearch, setSearchResult);
    }

    // video selected from the search response
    if (command === 'setVideoId') {
      //  console.log('setting video id ' + param);
      setSearchResult([]);
      // @ts-ignore
      setVideoId((videoId) => [...videoId, param]);
    }
  };

  // if (flag.error === true) {
  //   setTimeout(() => {
  //     window.location.href = '/';
  //   }, 1000);
  // }

  return (
    <>
      {loading === true ? (
        <LoadingScreen />
      ) : flag.error === true ? (
        <ChatError flag={flag} />
      ) : (
        // editor component
        <>
          <Editor
            name={name}
            room={room}
            notifications={notifications}
            videoId={videoId}
            socket={socket}
            setSearchResult={setSearchResult}
            setLocalUser={setLocalUser}
            aceEditor={aceEditor}
            allUsers={allUsers}
            code={code}
            lastedit={lastedit}
            localUser={localUser}
            player={player}
            search={search}
            searchResult={searchResult}
          />
          {/* A popup that appears when a user tries to edit a line that belongs to another user. */}
          {lineOwnerMgr && lineOwnFeat && (
            <div className='popup'>
              <div className='popup_inner'>
                <p>
                  {`You cannot edit this line because it belongs to ${lineOwnerMgr.user}`}{' '}
                </p>
                <button
                  onClick={() => {
                    updateLineOwner(null);
                  }}
                >
                  close me
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};
export default Chat;
